import React from 'react';
import { Row, Col, Input, Form } from 'antd';

const SectionPog = ({ getPogSection }) => {
  const { TextArea } = Input;
  return (
    <>
      <Row>
        <Col span={24}>
          <Form.Item name="introPog" label="Introducción:">
            <TextArea
              placeholder={getPogSection?.introduction}
              defaultValue={getPogSection?.introduction}
              disabled={true}
              autoSize
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="subsection3" label="Subtítulo 3:">
            <TextArea
              placeholder={getPogSection?.subtitle3}
              defaultValue={getPogSection?.subtitle3}
              disabled={true}
              autoSize
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="notaPog" label="Nota:">
            <TextArea
              placeholder={getPogSection?.note}
              defaultValue={getPogSection?.note}
              disabled={true}
              autoSize
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default SectionPog;
